/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react';
import { AutocompleteInput, SimpleForm } from 'react-admin';
import { Typography, Card, Button, TextField } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import TaskCard from './TaskCard';
import { asyncFetch, returnUnknownOldDevice, returnOldDevices } from '../../helperFunctions';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import TransferToCellMaterials from './TransferToCellMaterials';
import DeviceCard from './DeviceCard';
import OldDeviceCard from './OldDeviceCard';
import { setData, setConfirmationDialog, setSnackbar, setSapMaterials } from '../redux';
import { ticketTypesCpeReturn } from '../../constants';

export default () => {
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();
  const data = useSelector(state => state.tasks.data);
  const showTaskDetails = useSelector(state => state.tasks.showTaskDetails);
  const featuresList = useSelector(state => state.features.featuresList);
  const task = data.tasks.find(x => x.id === showTaskDetails.taskId);
  const taskStarted = useSelector(state => state.tasks.taskStarted);
  const sapMaterials = useSelector(state => state.tasks.sapMaterials);

  const fontSize = width <= 500 ? '4vw' : '20px';
  const [unknownSerialNumber, setUnknownSerialNumber] = useState('');
  const [sapMaterialId, setSapMaterialId] = useState('');
  const processedOldDevices = useSelector(state => state.tasks.data.processedOldDevices);

  const hasReturnDevices =
    task &&
    task.ticketTypeId &&
    (task.ticketTypeId === ticketTypesCpeReturn.ChangeTechnology ||
      task.ticketTypeId === ticketTypesCpeReturn.InstalationMigration) &&
    task.oldDevices &&
    task.oldDevices.length > 0;

  useEffect(() => {
    task &&
      (async () => {
        const response = await asyncFetch(
          `${process.env.REACT_APP_TECHNICIANS_API}/Tasks/get-task-devices?taskId=${task.id}`,
          undefined,
          undefined,
          undefined,
          dispatch
        );

        if (JSON.stringify(response) !== JSON.stringify(task.devices)) {
          const updatedTasks = [...data.tasks];
          updatedTasks.splice(data.tasks.indexOf(task), 1, { ...task, devices: response });
          dispatch(
            setData({
              ...data,
              tasks: updatedTasks,
            })
          );
        }
      })();

    task &&
      (async () => {
        const response = await asyncFetch(
          `${process.env.REACT_APP_TECHNICIANS_API}/Tasks/get-old-task-devices?taskId=${task.id}`,
          undefined,
          undefined,
          undefined,
          dispatch
        );
        if (JSON.stringify(response) !== JSON.stringify(task.oldDevices)) {
          const updatedTasks = [...data.tasks];
          updatedTasks.splice(data.tasks.indexOf(task), 1, {
            ...task,
            oldDevices: response,
          });
          dispatch(
            setData({
              ...data,
              tasks: updatedTasks,
              processedOldDevices: [],
            })
          );
        }
      })();
  }, [data, task, featuresList, sapMaterials, dispatch]);

  useEffect(() => {
    if (hasReturnDevices && sapMaterials === undefined) {
      (async () => {
        const response = await asyncFetch(
          `${process.env.REACT_APP_TECHNICIANS_API}/Tasks/get-cpe-materials/`,
          undefined,
          undefined,
          undefined,
          dispatch
        );

        const materials = response && response.isSuccess ? response.cpeMaterials : [];
        dispatch(setSapMaterials(materials.map(x => ({ id: x.materialId, name: x.materialInfo }))));
      })();
    }
  }, [hasReturnDevices, sapMaterials, dispatch]);

  const isTaskStarted = taskStarted.started && task && taskStarted.taskId === task.id;

  const isValidUnknownSerialNumber = (oldDevices, unknownSerialNumber) => {
    const found = oldDevices.find(x => x.serialNumber === unknownSerialNumber);

    return found === undefined;
  };

  // eslint-disable-next-line consistent-return
  const isSaveAllDisabled = (processedOldDevices, oldDevices) => {
    let isSaveAllDisabled = true;

    if (!processedOldDevices) return isSaveAllDisabled;

    if (!oldDevices) return isSaveAllDisabled;

    if (processedOldDevices && processedOldDevices.length <= 0) {
      isSaveAllDisabled = processedOldDevices && processedOldDevices.length <= 0;

      return isSaveAllDisabled;
    }

    if (oldDevices.length > 0 && processedOldDevices.length < oldDevices.length) {
      isSaveAllDisabled = oldDevices.length > 0 && processedOldDevices.length < oldDevices.length;

      return isSaveAllDisabled;
    }
    for (let index = 0; index < processedOldDevices.length; index++) {
      const element = processedOldDevices[index];

      isSaveAllDisabled = element && !element.isValidForBackend;

      if (isSaveAllDisabled) {
        return isSaveAllDisabled;
      }
    }

    isSaveAllDisabled = false;

    return isSaveAllDisabled;
  };

  return showTaskDetails.open && task ? (
    <>
      <Card style={{ marginTop: '5px' }}>
        <TaskCard task={task} />
      </Card>
      <Card style={{ marginTop: '3px' }}>
        <div style={{ backgroundColor: '#da291c', padding: '3px' }}>
          <Typography
            gutterBottom
            component="span"
            style={{ fontSize, color: 'white', padding: '1px' }}
          >
            Устройтва
          </Typography>
        </div>
        {task.devices &&
          task.devices.map(x => {
            return <DeviceCard key={x.id} device={x} task={task} />;
          })}
      </Card>
      {hasReturnDevices ? (
        <>
          <Card style={{ marginTop: '3px', marginBottom: '10px' }}>
            <div style={{ backgroundColor: '#da291c', padding: '3px' }}>
              <Typography
                gutterBottom
                component="span"
                style={{ fontSize, color: 'white', padding: '1px' }}
              >
                Стари Устройства
              </Typography>
            </div>
            {task.oldDevices.map(x => {
              return <OldDeviceCard key={x.id} device={x} task={task} />;
            })}
            {isTaskStarted ? (
              <Button
                style={{ marginBottom: '10px' }}
                fullWidth
                variant="contained"
                disabled={isSaveAllDisabled(processedOldDevices, task.oldDevices)}
                onClick={() =>
                  dispatch(
                    setConfirmationDialog({
                      open: true,
                      title: [
                        {
                          text:
                            'С потвърждаване на това действие няма да имате възможност за корекция. Ще зачислите взетите устройства в клетката си или ще начислите неустойка на клиента за невзетите?',
                        },
                      ],
                      onConfirm: () =>
                        returnOldDevices(processedOldDevices, task.id, data, dispatch),
                      onCancel: () =>
                        dispatch(
                          setConfirmationDialog({
                            open: false,
                            title: [],
                            onConfirm: null,
                            onCancel: null,
                          })
                        ),
                    })
                  )
                }
              >
                Запази всички
              </Button>
            ) : null}
            {isTaskStarted ? (
              <Card style={{ marginTop: '10px' }}>
                <div style={{ backgroundColor: '#da291c', padding: '3px' }}>
                  <Typography
                    gutterBottom
                    component="span"
                    style={{ fontSize, color: 'white', padding: '1px' }}
                  >
                    Неописано оборудване
                  </Typography>
                </div>
                <TextField
                  style={{ marginTop: '10px', marginBottom: '10px' }}
                  fullWidth
                  id="outlined-basic"
                  onChange={x => setUnknownSerialNumber(x.target.value)}
                  label="Serial number"
                  variant="outlined"
                />
                <SimpleForm toolbar={null}>
                  <AutocompleteInput
                    style={{ marginTop: '10px', marginBottom: '10px' }}
                    variant="standard"
                    suggestionLimit={10}
                    fullWidth
                    label="Материал"
                    source="material"
                    choices={sapMaterials ?? []}
                    emptyText="Изчисти филтър"
                    onChange={x => {
                      setSapMaterialId(x);
                    }}
                  />
                </SimpleForm>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => {
                    if (!isValidUnknownSerialNumber(task.oldDevices, unknownSerialNumber)) {
                      dispatch(
                        setSnackbar({
                          open: true,
                          message: `Сериен номер ${unknownSerialNumber} е наличен, моля извършете действията в стари устройства!`,
                        })
                      );
                    } else {
                      returnUnknownOldDevice(
                        task.id,
                        unknownSerialNumber,
                        sapMaterialId,
                        data,
                        dispatch
                      );
                    }
                  }}
                >
                  Запази
                </Button>
              </Card>
            ) : null}
          </Card>
        </>
      ) : null}
      <TransferToCellMaterials />
    </>
  ) : null;
};
